<template>
  <div>
    <component
      v-if="topModal"
      :is="topModal.template"
      :data="topModal.data"
      @close="close"
      @confirm="confirm"
    />
    <div class="modal-backdrop fade" :class="{ show: topModal }" v-if="topModal"></div>
  </div>
</template>

<script>
import store from "@/store";
import { useModals } from "@/utils";

export default {
  name: "ModalService",
  props: {},
  setup() {
    const { topModal } = useModals();
    const close = () => {
      store.dispatch("modals/close", topModal.value);
    };

    const confirm = () => {
      store.dispatch("modals/confirm", topModal.value);
    };

    return {
      topModal,
      close,
      confirm,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables";
</style>
